import { MAX_QUIZ_COUNT } from '../../../constant';
import {
  AI_GENERATE_DOCK_COUNT_PRESETS,
  AI_GENERATE_DOCK_DEFAULT_COUNT,
  type AiGenerateDockCountPreset,
} from '../consts/aiGenerateDock.const';

/** 문제 수 프리셋 — 남은 칸과 상관없이 다 고를 수 있다(10/23 지민). 보낼 수는 count 가 남은 칸만큼으로 줄인다. */
export type AiGenerateDockCountOption = {
  value: AiGenerateDockCountPreset;
};

export type AiGenerateDockCountState =
  | { locked: true; options: AiGenerateDockCountOption[] }
  | {
      locked: false;
      options: AiGenerateDockCountOption[];
      /** 실제로 보낼 문항 수 */
      count: number;
    };

export const getRemainingQuizSlots = (currentQuizCount: number) =>
  Math.max(MAX_QUIZ_COUNT - currentQuizCount, 0);

/**
 * 남은 칸으로 보낼 문항 수를 정한다. 프리셋은 늘 다 고를 수 있다.
 * 고른 값이 없으면 기본 10, 남은 칸보다 크면 남은 칸만큼으로 줄인다.
 */
export const resolveAiGenerateDockCount = ({
  remaining,
  selected,
}: {
  remaining: number;
  selected?: number | null;
}): AiGenerateDockCountState => {
  const options = AI_GENERATE_DOCK_COUNT_PRESETS.map(value => ({ value }));

  if (remaining <= 0) return { locked: true, options };

  const count = Math.min(selected ?? AI_GENERATE_DOCK_DEFAULT_COUNT, remaining);
  return { locked: false, options, count };
};
